import { z } from "zod";
import { isAddress, getAddress } from "viem";
export class ConfigError extends Error {
    missing;
    invalid;
    constructor(missing, invalid) {
        const lines = [];
        if (missing.length > 0) {
            lines.push(`Missing required environment variables: ${missing.join(", ")}`);
        }
        for (const item of invalid) {
            lines.push(`Invalid environment variable ${item.key}: ${item.reason}`);
        }
        super(`Configuration validation failed.\n${lines.join("\n")}`);
        this.missing = missing;
        this.invalid = invalid;
        this.name = "ConfigError";
    }
}
export const evmAddress = z
    .string()
    .refine((value) => isAddress(value), {
    message: "must be a valid EVM address (0x-prefixed, 40 hex chars)",
})
    .transform((value) => getAddress(value));
export const httpUrl = z
    .string()
    .url()
    .refine((value) => /^https?:\/\//.test(value), {
    message: "must be an http(s) URL",
});
export const positiveInt = z.coerce.number().int().positive();
export const nonNegativeInt = z.coerce.number().int().nonnegative();
export const bigintString = z
    .string()
    .refine((value) => /^\d+$/.test(value), { message: "must be a non-negative integer string" })
    .transform((value) => BigInt(value));
/**
 * Validates `source` against `schema`, collecting every missing/invalid field before
 * throwing so a service fails fast at startup with one complete error instead of one
 * variable at a time.
 */
export function parseEnv(schema, source = process.env) {
    const result = schema.safeParse(source);
    if (result.success) {
        return result.data;
    }
    const missing = [];
    const invalid = [];
    for (const issue of result.error.issues) {
        const key = issue.path.join(".");
        if (issue.code === "invalid_type" && issue.received === "undefined") {
            missing.push(key);
        }
        else {
            invalid.push({ key, reason: issue.message });
        }
    }
    throw new ConfigError(missing, invalid);
}
//# sourceMappingURL=parse.js.map